<template>
  <div class="contact-page">
    <div class="contact-container">
      <header class="contact-header">
        <h1 class="title">
          <span class="title-gradient">Get In Touch</span>
        </h1>
        <p class="subtitle">
          Kami selalu siap mendengar dari Anda. Baik itu pertanyaan, masukan, atau sekadar ingin menyapa, jangan ragu untuk menghubungi kami.
        </p>
      </header>

      <main class="contact-main">
        <div class="contact-info-wrapper">
          <div class="contact-card">
            <div class="icon-wrapper" style="background-color: #e0f2fe;">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0ea5e9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
            </div>
            <div class="text-content">
              <h3>Alamat Kantor</h3>
              <p>Gedung Amaris lt 2, Jl. Pemuda No.138, Sekayu, Kec. Semarang Tengah, Kota Semarang, Jawa Tengah 50139</p>
            </div>
          </div>

          <div class="contact-card">
            <div class="icon-wrapper" style="background-color: #dcfce7;">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
            </div>
            <div class="text-content">
              <h3>Telepon</h3>
              <p>(024) 3516972</p>
            </div>
          </div>

          <div class="contact-card">
            <div class="icon-wrapper" style="background-color: #ffedd5;">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f97316" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
            </div>
            <div class="text-content">
              <h3>Email</h3>
              <p>recruitment@nasmoco.co.id</p>
            </div>
          </div>
        </div>

        <div class="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.233999395463!2d110.4191195759108!3d-6.981666468371389!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e708b5f20337247%3A0x28c35b39520c3b93!2sNasmoco%20Group!5e0!3m2!1sen!2sid!4v1700000000000!5m2!1sen!2sid"
            width="100%"
            height="100%"
            style="border:0;"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            title="Peta Lokasi Kantor Nasmoco"
          ></iframe>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CareerContact',
  metaInfo() {
    const canonicalUrl = `https://nasmoco.co.id${this.$route.path}`;
    return {
      title: "Hubungi Kami - Nasmoco Karir",
      link: [
        {
          rel: "canonical",
          href: canonicalUrl,
        },
      ],
      meta: [
        { name: "description", content: "Hubungi tim Human Capital Nasmoco Group. Temukan alamat, nomor telepon, dan email kami." },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Hubungi Tim Karir Nasmoco Group",
            "description": "Halaman kontak untuk pertanyaan terkait karir dan rekrutmen di Nasmoco Group. Temukan alamat, telepon, dan email Human Capital kami.",
            "url": canonicalUrl,
            "mainEntity": {
              "@type": "Organization",
              "name": "Nasmoco Group",
              "telephone": "+62243516972",
              "email": "recruitment@nasmoco.co.id"
            }
          }
        }
      ]
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700;800&display=swap');

.contact-page {
  font-family: 'Poppins', sans-serif;
  background-color: #f8fafc;
  padding: 4rem 2rem;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contact-container {
  width: 100%;
  max-width: 1200px;
}

.contact-header {
  text-align: center;
  margin-bottom: 4rem;
}

.title {
  font-size: clamp(2.5rem, 5vw, 3.5rem);
  font-weight: 800;
  margin-bottom: 1rem;
  color: #1e293b;
}

.title-gradient {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}

.subtitle {
  font-size: clamp(1rem, 2.5vw, 1.125rem);
  color: #475569;
  max-width: 650px;
  margin: 0 auto;
  line-height: 1.6;
}

.contact-main {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 3rem;
  background: #ffffff;
  padding: 3rem;
  border-radius: 2rem;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.1);
}

.contact-info-wrapper {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.contact-card {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  padding: 1.5rem;
  border-radius: 1rem;
  background-color: #f8fafc;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.contact-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.07);
}

.icon-wrapper {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.text-content h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem 0;
}

.text-content p {
  margin: 0;
  color: #475569;
  line-height: 1.6;
}

.map-container {
  border-radius: 1.5rem;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  min-height: 400px;
}

.map-container iframe {
  filter: grayscale(100%) contrast(1.2) opacity(0.9);
  transition: filter 0.4s ease;
}

.map-container:hover iframe {
  filter: grayscale(0%);
}

/* Responsive */
@media (max-width: 992px) {
  .contact-main {
    grid-template-columns: 1fr;
    padding: 2rem;
  }
  .map-container {
    height: 350px;
  }
}

@media (max-width: 768px) {
  .contact-page {
    padding: 2rem 1rem;
  }
  .contact-main {
    border-radius: 1.5rem;
  }
  .contact-card {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
</style>
